import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResultOfT } from 'src/app/shared/models/response/result';
import { BaseService } from 'src/app/shared/services/base.service';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { WipStatusBTmapping } from '../shared/models/common/wip-status';

@Injectable({
  providedIn: 'root'
})
export class WipStatusBtService extends BaseService {
  ctrl = 'wip-status-bt';
  constructor(http: HttpClient, webStorageService: WebStorageService) {
    super(http, webStorageService);
  }

  getMappings() {
    return this.get<ResultOfT<WipStatusBTmapping[]>>(this.ctrl + '/mappings');
  }
}
